export interface GarageModItem {
  id: string
  name: string
  brand: string
}

export interface GarageModCategory {
  id: string
  label: string
  items: GarageModItem[]
}

export interface GarageVehicle {
  id: string
  name: string
  subtitle: string
  modCount: number
  categoryCount: number
  coverClassName: string
  buildList: GarageModCategory[]
}

export const garageVehiclesMock: GarageVehicle[] = [
  {
    id: 'wknd-warrior',
    name: 'Weekend Warrior',
    subtitle: '2019 Jeep Wrangler - Rubicon JL',
    modCount: 4,
    categoryCount: 4,
    coverClassName: 'from-earth-800 via-earth-700 to-adventure-700',
    buildList: [
      { id: 'armor', label: 'Armor', items: [{ id: 'armor-1', name: 'Rock Sliders', brand: 'Metalcloak' }] },
      { id: 'recovery', label: 'Recovery', items: [{ id: 'recovery-1', name: 'Winch 12k', brand: 'Warn Zeon 12-S' }] },
      { id: 'suspension', label: 'Suspension', items: [{ id: 'suspension-1', name: 'Fox 2.5 Coilovers', brand: 'Fox' }] },
      { id: 'tires', label: 'Tires', items: [{ id: 'tires-1', name: '37" KM3 Mud-Terrain', brand: 'BFGoodrich' }] },
    ],
  },
  {
    id: 'overlander',
    name: 'The Overlander',
    subtitle: '2021 Toyota 4Runner - TRD Off-Road',
    modCount: 8,
    categoryCount: 5,
    coverClassName: 'from-adventure-900 via-adventure-800 to-earth-700',
    buildList: [
      { id: 'storage', label: 'Storage', items: [{ id: 'storage-1', name: 'Rear Drawer System', brand: 'Goose Gear' }] },
      { id: 'roof', label: 'Roof', items: [{ id: 'roof-1', name: 'Roof Rack Platform', brand: 'Prinsu' }] },
      { id: 'camp', label: 'Camp Setup', items: [{ id: 'camp-1', name: '270 Awning', brand: 'Alu-Cab' }] },
      { id: 'lighting', label: 'Lighting', items: [{ id: 'lighting-1', name: 'Bumper Light Bar', brand: 'Baja Designs' }] },
      { id: 'electrical', label: 'Electrical', items: [{ id: 'electrical-1', name: 'Dual Battery Kit', brand: 'Redarc' }] },
    ],
  },
  {
    id: 'daily-rig',
    name: 'Daily / Tow Rig',
    subtitle: '2023 Ford F-150 - Tremor',
    modCount: 3,
    categoryCount: 3,
    coverClassName: 'from-earth-900 via-earth-800 to-earth-700',
    buildList: [
      { id: 'tow', label: 'Tow', items: [{ id: 'tow-1', name: 'Tow Mirrors', brand: 'OEM Ford' }] },
      { id: 'bed', label: 'Bed Setup', items: [{ id: 'bed-1', name: 'Decked Drawer', brand: 'Decked' }] },
      { id: 'tires-f150', label: 'Tires', items: [{ id: 'tires-f150-1', name: '35" Trail Terrain', brand: 'Nitto' }] },
    ],
  },
]
